module.exports = __webpack_public_path__ + "img/Group 12.576d640b.svg";